export const STAGES = [
  { key: "lead", label: "Lead" },
  { key: "engagement", label: "Engagement" },
  { key: "organizer", label: "Organizer" },
  { key: "waiting_docs", label: "Waiting Docs" },
  { key: "preparation", label: "Preparation" },
  { key: "cpa_review", label: "CPA Review" },
  { key: "client_review", label: "Client Review" },
  { key: "e8879", label: "8879" },
  { key: "ready_efile", label: "Ready to E-file" },
  { key: "accepted", label: "Accepted" },
  { key: "archived", label: "Archived" },
];

export const stageLabel = (k) => STAGES.find((s) => s.key === k)?.label || k;

export const DRAFT_TYPES = [
  { key: "client_email", label: "Client Email" },
  { key: "missing_docs_email", label: "Missing Docs Request" },
  { key: "engagement_letter", label: "Engagement Letter" },
  { key: "organizer_questionnaire", label: "Organizer Questionnaire" },
  { key: "task_list", label: "Task List" },
  { key: "irs_notice_response", label: "IRS Notice Response" },
  { key: "workflow_move", label: "Workflow Suggestion" },
];

export const ENTITY_TYPES = ["Individual", "LLC", "S-Corp", "C-Corp", "Partnership", "Trust"];
export const SERVICE_TYPES = ["1040 Individual", "1120-S S-Corp", "1120 C-Corp", "1065 Partnership", "1041 Trust", "990 Non-Profit"];

export function confBadge(v) {
  if (v == null) return "bg-zinc-100 text-zinc-500 border border-zinc-200";
  if (v >= 0.85) return "bg-emerald-50 text-emerald-700 border border-emerald-200";
  if (v >= 0.6) return "bg-amber-50 text-amber-700 border border-amber-200";
  return "bg-rose-50 text-rose-700 border border-rose-200";
}

export function riskBadge(v) {
  if (v == null) return "bg-zinc-100 text-zinc-500 border border-zinc-200";
  if (v <= 0.2) return "bg-emerald-50 text-emerald-700 border border-emerald-200";
  if (v <= 0.45) return "bg-amber-50 text-amber-700 border border-amber-200";
  return "bg-rose-50 text-rose-700 border border-rose-200";
}
